
document.addEventListener("DOMContentLoaded", function () {
  const quantityInputs = document.querySelectorAll('.sync-quantity');

  quantityInputs.forEach(input => {
    input.addEventListener('change', function (e) {
      const newValue = e.target.value;
      quantityInputs.forEach(otherInput => {
        if (otherInput !== e.target) {
          otherInput.value = newValue;
          otherInput.dispatchEvent(new Event('change')); // Optional: trigger change on the second input too
        }
      });
    });
  });
});
